import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '_helpers';

const name = 'preAlerts';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports
export const preAlertActions = { ...slice.actions, ...extraActions };
export const preAlertReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        list: null,
        item: null,
        variables: null,
        isLoading: false,
        error: null,
    };
}

function createReducers() {
    return {
        setPreAlert,
        clearPreAlert
    };

    function setPreAlert(state, action) {
        state.item = action.payload;
    }

    function clearPreAlert(state){
        state.item = null;
    }
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getAll: getAll(),
        create: create(),
        update: update(),
        delete: _delete(),
        getVariables: getVariables()
    };

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/preAlertes`)
        );
    }

    function create() {
        return createAsyncThunk(
            `${name}/create`,
            async (preAlerte) => await fetchWrapper.post(`${baseUrl}/preAlerte`, preAlerte)
        );
    }

    function update() {
        return createAsyncThunk(
            `${name}/update`,
            async function(preAlert) {
                await fetchWrapper.put(`${baseUrl}/preAlerte/${preAlert.id}`, preAlert);
            }
        );
    }

    function _delete() {
        return createAsyncThunk(
            `${name}/delete`,
            async (id) => {
                await fetchWrapper.delete(`${baseUrl}/preAlerte/${id}`);
                return id;
            }
        );
    }

    function getVariables() {
        return createAsyncThunk(
            `${name}/getVariables`,
            async () => await fetchWrapper.get(`${baseUrl}/variables_preAlerte`)
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getAll();
        //update();
        _delete();
        getVariables();

        function getAll() {
            var { pending, fulfilled, rejected } = extraActions.getAll;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.list = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des pré-alertes';
                });
        }

        /*function update() {
            var { fulfilled } = extraActions.update;
            builder.addCase(fulfilled, (state, action) => {
                const index = state.list.value.findIndex(x => x.id === action.payload.id);
                if (index !== -1) {
                    state.list.value[index] = { ...state.list.value[index], ...action.payload.data };
                }
            });
        }*/

        function _delete() {
            var { pending, fulfilled, rejected } = extraActions.delete;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de suppression de la pré-alerte';
                });
        }

        function getVariables() {
            var { pending, fulfilled, rejected } = extraActions.getVariables;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.variables = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des variables';
                });
        }
    };
}

export default preAlertReducer;

